export default __webpack_public_path__ + "img/3db8e07fad9457dd241d20f5e8cf80cc.png";